import { z } from "zod";
import { SUGGESTION_TYPE_VALUES, type Suggestion } from "../types.ts";

export const SUGGESTION_TYPES = SUGGESTION_TYPE_VALUES;
export const MAX_SUGGESTION_CANDIDATES = 3;
export const MAX_SUGGESTION_TOPICS = 6;

export const suggestionObjectSchema = z.object({
  type: z.enum(SUGGESTION_TYPES),
  title: z.string(),
  prompt: z.string(),
  rationale: z.string(),
  evidence: z.array(z.string().trim().min(1)).min(1).max(2),
});

export function normalizeSuggestionCandidateCount(candidateCount = MAX_SUGGESTION_CANDIDATES): number {
  return Math.max(1, Math.min(MAX_SUGGESTION_CANDIDATES, Math.floor(candidateCount)));
}

export function buildSuggestionResponseSchema(candidateCount = MAX_SUGGESTION_CANDIDATES) {
  const maxCandidates = normalizeSuggestionCandidateCount(candidateCount);
  return z.object({
    suggestions: z.array(suggestionObjectSchema).max(maxCandidates),
    topics: z.array(z.string()).max(MAX_SUGGESTION_TOPICS),
  });
}

export const suggestionResponseSchema = buildSuggestionResponseSchema();

export type SuggestionObject = z.infer<typeof suggestionObjectSchema>;
export type SuggestionResponse = z.infer<typeof suggestionResponseSchema>;

export type NormalizedGeneratedSuggestion = Omit<
  Suggestion,
  "id" | "ts" | "status" | "provider" | "edited"
> & {
  signature: string;
};
